import React from "react";
import ReactDOM from "react-dom/client";
import "./index.less";
import App from "./App";
import "@arco-design/web-react/dist/css/arco.css";
import reportWebVitals from "./reportWebVitals";
import "./public-path";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
reportWebVitals();
